
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import DropZonesOverlayDOMAPI from './DropZonesOverlayDOMAPI';
import Overlay from '../Overlay';
import OverlayConfig from '../OverlayConfig.json';
const APIFactory = require('gemini/lib/@waca/dashboard-common/dist/core/APIFactory');

class DropZonesOverlayDOM {

	constructor(options) {
		this._content = options.content;
		this._dashboard = options.features['Dashboard.API'];
		this._overlayState = options.features['DropZonesOverlayState'];
		this._logger = options.features['Dashboard.Logger'];
	}

	getAPI() {
		if (!this._api) {
			this._api = APIFactory.createAPI(this, [DropZonesOverlayDOMAPI]);
		}
		return this._api;
	}

	getContentMenuList() {
		if (this._overlayState.isEnabled()) {
			return [{
				id: 'showHideOverlay',
				action: this.render
			}];
		}
		return [];
	}

	render() {
		const contentViewDOMFeature = this._content.getFeature('ContentViewDOM');
		const contentNode = contentViewDOMFeature && contentViewDOMFeature.getNode().querySelector('.widgetContent');
		if (contentNode) {
			const SLOTS_ID_POSITION_MAP = OverlayConfig;
			const visType = this._content.getFeature('Visualization').getType();
			if(!SLOTS_ID_POSITION_MAP[visType]){
				// not a vis type that we want to show drop zones
				return null;
			}
			this._overLayParentNode = contentNode.querySelector('.dropZoneOverlay');
			if (this._overLayParentNode) {
				this.unmount(this._overLayParentNode);
			} else {
				this._overLayParentNode = document.createElement('div');
				this._overLayParentNode.classList.add('dropZoneOverlay');
				contentNode.appendChild(this._overLayParentNode);
			}
			ReactDOM.render(
				<Overlay
					content={this._content}
					overlayModel={this._overlayState.getModel()}
					dashboard={this._dashboard}
					logger={this._logger}
					overlayParentNode={this._overLayParentNode}
				/>,
				this._overLayParentNode
			);
		}
	}

	isMounted() {
		return !! this._overLayParentNode;
	}

	unmount() {
		if(this._overLayParentNode){
			ReactDOM.unmountComponentAtNode(this._overLayParentNode);
		}
	}

	reassessDropTarget(node) {
		if(!node){
			const contentViewDOMFeature= this._content.getFeature('ContentViewDOM');
			node = contentViewDOMFeature && contentViewDOMFeature.getNode();
		}
		if(node){
			const dnd = this._dashboard.getFeature('.DndManager');
			dnd.reassessContainer(node);
		}
	}

	destroy() {
		this.unmount();
		this._api = null;
	}
}

module.exports = DropZonesOverlayDOM;


// WEBPACK FOOTER //
// ./src/js/dashboard/DropZonesOverlayDOM.js